import React, {FC} from "react"

import Flex from "@irati/ui/src/Flex"
import {Body, H2, H4} from "@irati/ui/src/Typography"
import {useTheme} from "@irati/ui/src/global/useTheme"
import FormattedMessage, {useIntl} from "@irati/utils/lang"
import {formatCurrency} from "@irati/utils/currency/formatCurrency"
import {PaymentCurrencyType, StoryEngagement, StorySavings} from "@irati/types"

import {LinearGradiantCard} from "./styled"

interface Props {
  currencyCode: PaymentCurrencyType
  engagedUsers?: StoryEngagement
  savings?: StorySavings
}

const SavingsEngagement: FC<Props> = ({currencyCode, savings, engagedUsers}) => {
  const theme = useTheme()
  const {formatMessage, formatNumber} = useIntl()

  return (
    <Flex gap={1}>
      {savings && (
        <LinearGradiantCard marginBottom c1={theme.colors.primary1} c2={theme.colors.success}>
          <Flex gap={1} alignItems="center">
            <img src={formatMessage({id: "admin.components.yourPerkboxStory.savings.img"})} width={82} height={82} />
            <div>
              <Flex alignItems="center" gap={0.5}>
                <H2 color={theme.colors.greys.white}>
                  {formatCurrency({
                    isCents: false,
                    value: currencyCode === PaymentCurrencyType.Gbp ? savings?.totalSavingsGbp : savings?.totalSavingsAud,
                    currencyCode
                  })}
                </H2>
                <H4 color={theme.colors.greys.white}>
                  <FormattedMessage id="admin.components.yourPerkboxStory.savings.title" />
                </H4>
              </Flex>
              <Body color={theme.colors.greys.white} maxWidth="100%" small>
                <FormattedMessage
                  id="admin.components.yourPerkboxStory.savings.text"
                  values={{
                    coffees: (
                      <Body weight="bold" display="inline" color={theme.colors.greys.white}>
                        {formatNumber(savings.coffees!)}
                      </Body>
                    )
                  }}
                />
              </Body>
            </div>
          </Flex>
        </LinearGradiantCard>
      )}
      {engagedUsers && (
        <LinearGradiantCard marginBottom c1={theme.colors.primary1} c2={theme.colors.success}>
          <Flex gap={1} alignItems="center">
            <img src={formatMessage({id: "admin.components.yourPerkboxStory.engagement.img"})} width={82} height={82} />
            <div>
              <H2 color={theme.colors.greys.white}>
                <FormattedMessage id="admin.components.yourPerkboxStory.engagement.title" />
              </H2>
              <Body color={theme.colors.greys.white} maxWidth="100%" small>
                <FormattedMessage
                  id="admin.components.yourPerkboxStory.engagement.text"
                  values={{
                    engagedUsers: (
                      <Body weight="bold" display="inline" color={theme.colors.greys.white}>
                        {formatNumber(engagedUsers.engagedUsers!)}
                      </Body>
                    )
                  }}
                />
              </Body>
            </div>
          </Flex>
        </LinearGradiantCard>
      )}
    </Flex>
  )
}

export default SavingsEngagement
